import images from './project.jpg'
import React, { useState, useEffect } from 'react';
import './index.css'
import axios from 'axios';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';

const ProjectPage = () => {
    const [allProjects, setAllProjects] = useState([]);
    const [loading, setLoading] = useState(true);
    const currentDate = new Date();
    const navigate = useNavigate();

    useEffect(() => {
        AOS.init({
            duration: 1000,
            offset: 100,
            once: true
        });

        axios.get(process.env.REACT_APP_BASE_URL + '/api/projects')
            .then(res => {
                const sortedProjects = res.data
                    .map(project => ({
                        ...project,
                        startDate: moment(project.startDate).format('YYYY-MM-DD'),
                        endDate: moment(project.endDate).format('YYYY-MM-DD')
                    }))
                    .sort((a, b) => moment(b.endDate).toDate() - moment(a.endDate).toDate());
                setAllProjects(sortedProjects);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error fetching projects:', error);
                setLoading(false);
            });
    }, []);

    return (
        <div className="project-page-wrapper">
            {/* Hero Section */}
            <section className="project-hero-section">
                <div className="project-hero-overlay"></div>
                <img src={images} alt="project" className="project-hero-image" />
                <div className="project-hero-content" data-aos="fade-up">
                    <h1 className="project-hero-title">Our Projects</h1>
                    <p className="project-hero-subtitle">Discover our portfolio of successful projects and ongoing developments</p>
                </div>
            </section>

            {/* Projects Section */}
            <section className="project-content-section">
                <div className="project-container">
                    <div className="project-header" data-aos="fade-up">
                        <h2 className="project-section-title">Project Showcase</h2>
                        <p className="project-section-subtitle">
                            Below are the projects we have completed and those that are currently in progress
                        </p>
                    </div>

                    {loading ? (
                        <div className="project-loading">
                            <div className="project-spinner"></div>
                            <p>Loading projects...</p>
                        </div>
                    ) : (
                        <div className="project-list-wrapper">
                            {allProjects.map((project, index) => (
                                <div 
                                    key={index} 
                                    className={`project-item-card ${index % 2 === 0 ? 'project-item-left' : 'project-item-right'}`}
                                    data-aos={index % 2 === 0 ? "fade-right" : "fade-left"}
                                    data-aos-delay={index * 100}
                                >
                                    <div className="project-item-content">
                                        <div className="project-item-header">
                                            <h3 className="project-item-title">
                                                <a href={project.link} target="_blank" rel="noopener noreferrer" className="project-link">
                                                    {project.title}
                                                </a>
                                            </h3>
                                            <span className={`project-status-badge ${new Date(project.endDate) < currentDate ? 'completed' : 'ongoing'}`}>
                                                {new Date(project.endDate) < currentDate ? 'Completed' : 'Ongoing'}
                                            </span>
                                        </div>
                                        <div className="project-item-details">
                                            <div className="project-detail-item">
                                                <span className="project-detail-label">Client:</span>
                                                <span className="project-detail-value">{project.client}</span>
                                            </div>
                                            <div className="project-detail-item">
                                                <span className="project-detail-label">Duration:</span>
                                                <span className="project-detail-value">{project.startDate} - {project.endDate}</span>
                                            </div>
                                            <div className="project-detail-item">
                                                <span className="project-detail-label">Contract Value:</span>
                                                <span className="project-detail-value">{project.contractValue} Millions</span>
                                            </div>
                                        </div>
                                        <p className="project-item-description">{project.description}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </section>

            {/* Footer */}
            <footer className="project-footer">
                <div className="project-container">
                    <small>
                        {new Date().getFullYear()} Copyright © Hong Yuan Construction Pte Ltd, UEN:200922798D
                    </small>
                </div>
            </footer>
        </div>
    );
};

export default ProjectPage;
